import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Spinner } from 'react-bootstrap';

/**
 * LandingPageResolver - Routes users to appropriate landing page based on their role
 *
 * Administrators and higher roles → Company Admin Dashboard
 * Techs and lower roles → Inspections Page
 */
const LandingPageResolver = () => {
  const history = useHistory();
  const { user, isSubdomainAdminOrHigher } = useAuth();

  useEffect(() => {
    if (user) {
      // Check if user is admin or higher (subdomainadmin, admin, limitedadmin, superadmin)
      if (isSubdomainAdminOrHigher()) {
        // Route to Company Admin Dashboard for admins and higher
        history.replace('/company_admin_dashboard');
      } else {
        // Route to Inspections page for techs and lower roles
        // (subdomaintech, subdomaincustomer, contractor, intern, guest)
        history.replace('/inspections');
      }
    }
  }, [user, isSubdomainAdminOrHigher, history]);

  // Show loading spinner while determining route
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh'
    }}>
      <div style={{ textAlign: 'center' }}>
        <Spinner animation="border" role="status" style={{ width: '3rem', height: '3rem' }}>
          <span className="sr-only">Loading...</span>
        </Spinner>
        <div style={{ marginTop: '1rem', fontSize: '1.2rem', color: '#6c757d' }}>
          Redirecting to your dashboard...
        </div>
      </div>
    </div>
  );
};

export default LandingPageResolver;